import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    key: String
  }

  connect() {
    if (this.isDismissed()) {
      this.element.remove()
    }
  }

  dismiss() {
    localStorage.setItem(this.storageKey, "true")
    this.element.remove()
  }

  isDismissed() {
    return localStorage.getItem(this.storageKey) === "true"
  }

  get storageKey() {
    return `dismissible_${this.keyValue}`
  }
}
